// HTTP 400 不得携带可能被调用方误判为成功的 content/data，业务码单独保留。
export const getPortalSecurityError = (error) => {
  const response = error && error.response;
  if (!response || response.status !== 400) return null;

  const data = response.data && typeof response.data === 'object' ? response.data : {};
  return {
    code: 400,
    success: false,
    httpStatus: 400,
    errorCode: data.code,
    // 部分旧页面仅检查 businessCode，必须同样置为失败，原值另存。
    businessCode: 400,
    errorBusinessCode: data.businessCode,
    message: typeof data.message === 'string' ? data.message : '请求未通过安全校验',
    requestId: error.config && error.config.requestId,
  };
};
